import React, { useEffect, useState } from 'react';
import { useAuthContext } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import { isOvum } from '../../utils/utils';
import { useLocation } from 'react-router-dom';

const SidebarWrapper: React.FC = () => {
  const { isAuthenticated } = useAuthContext();
  const location = useLocation();
  const { pathname } = location;
  const [toggle, setToggle] = useState(true);

  useEffect(() => {
    // This will use to trigger the rerender of the sidebar
    setToggle(!toggle);
  }, [isAuthenticated, pathname]);
  
  if(pathname === '/login') {
    return null;
  }

  if(isOvum() && pathname === '/') {
    return null;
  }

  if(!isAuthenticated) {
    return null;
  }
  return <Sidebar />;
};

export default SidebarWrapper;

